// pollyfill.io conditional polyfills that tries to replicate https://unpkg.com/browse/@firebase/polyfill@0.3.36/dist/index.cjs.js
var features = []; 

if (!window.fetch) {
  features.push('fetch');
} 

if (!window.Promise) {
  features.push('Promise');
} 

(function () {
  try {
    new Function("(a = 0) => a");
    return true;
  } catch (err) {
    features.push("es6");
    return false;
  }
})();

if (!window.Symbol) {
  features.push('Symbol');
} 

if (!window.Symbol || !window.Symbol.iterator) {
  features.push('Symbol.iterator');
} 

if (!window.Array.prototype.find) {
  features.push('Array.prototype.find');
} 

if (!window.Array.prototype.findIndex) {
  features.push('Array.prototype.findIndex');
}

if (!window.Array.prototype.some) {
  features.push('Array.prototype.some');
}

if (!window.Array.from) {
  features.push('Array.from');
}

if (!window.ArrayBuffer) {
  features.push('Array.prototype.%40%40iterator');
}

if (!window.Object.assign) {
  features.push('Object.assign');
}

if (!window.Object.entries) {
  features.push('Object.entries');
}

if (!window.Object.values) {
  features.push('Object.values');
}

if (!window.String.prototype.includes) {
  features.push('String.prototype.includes');
}

if (!window.String.prototype.startsWith) {
  features.push('String.prototype.startsWith');
}

if (!window.String.prototype.repeat) {
  features.push('String.prototype.repeat');
}

if (!window.Map) {
  features.push('Map');
}

if (!window.Set) {
  features.push('Set');
}

if (!window.Number.isInteger) {
  features.push('Number.isInteger');
}

if (features.length > 0) {
  var element = document.createElement('script');
  element.src = 'https://polyfill.io/v3/polyfill.min.js?features=' + features.join('%2C');
  element.async = false;
  document.getElementById('polyfills-js').insertAdjacentElement('afterend', element);
}